const CoFilterValue = [
  { name: 'name', operator: 'contains', type: 'string', value: '' },
  { name: 'company', operator: 'contains', type: 'string', value: '' },
  { name: 'jobTitle', operator: 'contains', type: 'string', value: '' },
  { name: 'businessPhone', operator: 'contains', type: 'string', value: '' },
  { name: 'emailAddress', operator: 'contains', type: 'string', value: '' },
];

export default CoFilterValue;
